import LinkCusstom from '@/components/common/LinkCusstom'
import SvgIcon from '@/components/common/SvgIcon'
import { Tooltip } from 'antd'
import {
  AlarmClockCheck,
  AudioLines,
  BadgeDollarSign,
  Banknote,
  BarChart3,
  BookOpenText,
  BookUser,
  BriefcaseBusiness,
  Calendar,
  CalendarCheck,
  CalendarCheck2,
  CalendarCheck2Icon,
  CalendarRange,
  ChartColumnIncreasing,
  CircleUser,
  ClipboardCheck,
  ClipboardMinus,
  Clock3,
  ClockAlert,
  Command,
  Contact,
  DoorOpen,
  FileCheck2,
  FileQuestion,
  FileText,
  FileUser,
  FolderSync,
  Gift,
  HeartHandshake,
  Home,
  Info,
  LandPlot,
  Layers,
  LayoutDashboard,
  ListChecks,
  MessageCircle,
  MessageSquareMore,
  Network,
  Receipt,
  RefreshCcw,
  ScanEye,
  ScrollText,
  Settings,
  SettingsIcon,
  ShieldAlert,
  ShieldCheck,
  SquareUserRound,
  Star,
  Tag,
  Tickets,
  TicketsIcon,
  UserCheck,
  UserCog,
  UserCog2,
  UserPlus,
  UserSearch,
  Users,
} from 'lucide-react'
import { ACS_MENU_CONFIG, ADMIN_MENU_CONFIG, HRM_MENU_CONFIG, USER_MENU_CONFIG } from './MenuConfig'
import ROUTER from './ROUTER'

// Type definition matches original
export interface MenuItem {
  key: string
  label: any
  tabid?: string[]
  children?: MenuItem[]
  [key: string]: any
}

// Icon Mapper
const IconMap: Record<string, any> = {
  AudioLines,
  BookOpenText,
  BookUser,
  CalendarCheck,
  Command,
  FileText,
  FolderSync,
  Gift,
  Info,
  ListChecks,
  MessageCircle,
  MessageSquareMore,
  Network,
  ScrollText,
  Settings,
  ShieldAlert,
  SquareUserRound,
  Home,
  RefreshCcw,
  BarChart3,
  CalendarRange,
  Layers,
  DoorOpen,
  ScanEye,
  Users,
  UserCheck,
  SettingsIcon,
  ShieldCheck,
  Calendar,
  CalendarCheck2,
  ClipboardMinus,
  Tickets,
  LandPlot,
  TicketsIcon,
  Tag,
  ClockAlert,
  CalendarCheck2Icon,
  UserCog,
  Contact,
  Banknote,
  ClipboardCheck,
  UserPlus,
  FileQuestion,
  Star,
  HeartHandshake,
  LayoutDashboard,
  CircleUser,
  UserSearch,
  UserCog2,
  Clock3,
  BadgeDollarSign,
  AlarmClockCheck,
  BriefcaseBusiness,
  FileCheck2,
  ChartColumnIncreasing,
  Receipt,
  FileUser,
}

const getIcon = (name: string) => {
  const Icon = IconMap[name]
  return Icon ? <Icon size={16} /> : null
}

// Recursive Mapper
const mapConfigToMenuItem = (item: any): MenuItem => {
  const hasPath = !!item.path

  return {
    ...item,
    key: item.key,
    label: hasPath ? (
      <LinkCusstom to={item.path}>{item.label}</LinkCusstom>
    ) : item?.type === 'group' ? (
      <div className="max-line1 fs-8 fw-600 pl-5" style={{ color: 'var(--color-primary)' }}>
        <Tooltip title={item.label} placement="right">
          {item.label}
        </Tooltip>
      </div>
    ) : (
      <div className="max-line1">
        <Tooltip title={item.label} placement="right">
          {item.label}
        </Tooltip>
      </div>
    ),
    icon: item.icon ? getIcon(item.icon) : null,
    tabid: item.tabid,
    children: item.children?.map(mapConfigToMenuItem),
  }
}

export const MenuItemAdmin = (): MenuItem[] => {
  return ADMIN_MENU_CONFIG.map(mapConfigToMenuItem)
}
export const MenuItemACS = (): MenuItem[] => {
  return ACS_MENU_CONFIG.map(mapConfigToMenuItem)
}
export const MenuItemHRM = (): MenuItem[] => {
  return HRM_MENU_CONFIG.map(mapConfigToMenuItem)
}

export const MenuItemUser = (): MenuItem[] => {
  return USER_MENU_CONFIG.map(mapConfigToMenuItem)
}

// Legacy exports kept for compatibility if needed
export const ListTitleRouter = () => []
export const MenuItemBreadcrumbs = () => [
  {
    label: 'Đổi mật khẩu',
    key: (ROUTER as any)?.CHANGE_PASSWORD || '/user/change-password',
  },
]

const MenuItem = () => {
  return [
    {
      key: ROUTER.HOME,
      icon: <SvgIcon name="home" />,
      align: 'center',
    },
  ]
}
export default MenuItem
